import type { ListToolbarSearchProps } from "./types-search";
import { useListToolbarSearch } from "./use-search";
import { ListToolbarSearchView } from "./view-search";

export function ListToolbarSearch(props: ListToolbarSearchProps) {
  return <ListToolbarSearchView {...useListToolbarSearch(props)} />;
}
ListToolbarSearch.displayName = "ListToolbar.Search";
